var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5V6.75C11 6.15326 10.7629 5.58097 10.341 5.15901C9.91903 4.73705 9.34674 4.5 8.75 4.5H7.75C7.55109 4.5 7.36032 4.42098 7.21967 4.28033C7.07902 4.13968 7 3.94891 7 3.75V2.75C7 2.15326 6.76295 1.58097 6.34099 1.15901C5.91903 0.737053 5.34674 0.5 4.75 0.5H3.5M3.5 9H8.5M3.5 11H6M5 0.5H1.75C1.336 0.5 1 0.836 1 1.25V12.75C1 13.164 1.336 13.5 1.75 13.5H10.25C10.664 13.5 11 13.164 11 12.75V6.5C11 4.9087 10.3679 3.38258 9.24264 2.25736C8.11742 1.13214 6.5913 0.5 5 0.5Z",
    stroke: "#4A526C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocGray);
export default __webpack_public_path__ + "static/media/DocGray.3fc2d7d6375a2e2a96af7d3eb77eac5f.svg";
export { ForwardRef as ReactComponent };